import React from 'react'
import './Inner_Loader.css'

export default function Inner_Loader() {
  return (
    <div className='inner-loader'>
      <span class="loader"></span>
    </div>
  )
}
